<template>
    <div class="midblock width100" style="margin-top:15px;">
        <table id="transfers"
            border="0"
            cellspacing="0px"
            cellpadding="10px"
            width="100%"
            class=" hoverme"
        >
            <tr
                valign="middle"
                class="pointer "
                v-on:click="setAndEmit(false, false, 0, false)"
                :class="{
                        selectedRow: !transfers.outboundTransfer &&
                            !transfers.inboundTransfer &&
                                !transfers.opAanvraag
                    }"
            >
                <td align="center">
                    <input
                        type="radio"
                        name="noTransfer"
                        value="NO"
                        :checked="
                            !transfers.outboundTransfer &&
                                !transfers.inboundTransfer &&
                                !transfers.opAanvraag
                        "
                    />
                </td>
                <td>
                    <strong>Geen transfers</strong>
                </td>

                <td
                    valign="middle"
                    :class="{
                        dim:
                            transfers.outboundTransfer ||
                            transfers.inboundTransfer ||
                            transfers.opAanvraag,
                    }"

                >
                  <div v-if="!transfers.outboundTransfer &&
                            !transfers.inboundTransfer &&
                                !transfers.opAanvraag" style="text-align: center;height:38px;line-height:38px;"><u><b>Geselecteerd</b></u></div>
                    <button v-else
                        class="btn btn-success btn-addon width100 font14 bold" style="margin-bottom: 5px;"
                      
                    >
                       Selecteer <font-awesome-icon icon="angle-right" />
                    </button>
                </td>
            </tr>

            <tr
                valign="middle"
                class="pointer "
                v-on:click="setAndEmit(false, false, 0, true)"
                :class="{
                        selectedRow: !transfers.outboundTransfer &&
                            !transfers.inboundTransfer &&
                            transfers.opAanvraag,
                    }"
            >
                <td align="center " class="sm-border" style="border-top: 1px solid #ddd;">
                    <input
                        type="radio"
                        name="opaanvr"
                        value="YES"
                        :checked="
                            !transfers.outboundTransfer &&
                                !transfers.inboundTransfer &&
                                transfers.opAanvraag
                        "
                    />
                </td>
                <td class="sm-hide-border" style="border-top: 1px solid #ddd;">
                    <strong
                        >Zoek andere transfers voor mij
                        <i>(prijs en beschikbaarheid op aanvraag)</i></strong
                    >
                </td>

                <td style="border-top: 1px solid #ddd;"

                    valign="middle"
                    :class="{
                        dim:
                            transfers.outboundTransfer ||
                            transfers.inboundTransfer ||
                            !transfers.opAanvraag,
                    }"
                >
                  <div v-if="  !transfers.outboundTransfer &&
                            !transfers.inboundTransfer &&
                            transfers.opAanvraag" style="text-align: center;height:38px;line-height:38px;"><u><b>Geselecteerd</b></u></div>
                  <button v-else
                          class="btn btn-success btn-addon width100 font14 bold" style="margin-bottom: 5px;"
                        
                  >
                    Selecteer <font-awesome-icon icon="angle-right" />
                  </button>
                </td>
            </tr>

            <tr
                v-if="
                    flights &&
                        flights.results &&
                        flights.results[0] &&
                        outboundTransferPrice > 0 &&
                        inboundTransferPrice > 0
                "
                class="pointer "
                v-on:click="
                    setAndEmit(
                        true,
                        true,
                        outboundTransferPrice + inboundTransferPrice,
                        false
                    )
                "
                :class="{
                        selectedRow: transfers.inboundTransfer &&
                            transfers.outboundTransfer
                    }"
            >
                <td align="center" class="sm-border" style="border-top: 1px solid #ddd;">
                    <input
                        type="radio"
                        name="inoutboundtransfer"
                        value="NO"
                        :checked="
                            transfers.inboundTransfer &
                                transfers.outboundTransfer
                        "
                    />
                </td>
                <td class="sm-hide-border" style="border-top: 1px solid #ddd;">
                    <div class="width90 sm-my-15 bottomborder" style="float:left;width:90%;">
                        <div style="float:left;width:5%;">
                            <font-awesome-icon icon="bus" />
                        </div>
                        <div
                            class="width90"
                            style="float:left;padding-left: 10px; width:calc(95% - 10px)"
                        >
                            Transfer van
                            <strong>{{
                                flights.results[0].outbound[0].arrivalAirport
                            }}</strong>
                            naar de <strong>Cruiseterminal</strong>
                        </div>
                        <div style="float:left;width:5%;">
                            <font-awesome-icon icon="bus" />
                        </div>
                        <div
                            class="width90"
                            style="float:left;padding-left: 10px; width:calc(95% - 10px)"
                        >
                            en terug van de <strong>Cruiseterminal</strong> naar
                            <strong>{{
                                flights.results[0].inbound[0].departureAirport
                            }}</strong
                            >.
                        </div>
                    </div>
                </td>
                <td
                    align="center"
                    style="border-top: 1px solid #ddd;"
                    :class="{
                        dim:
                            !transfers.outboundTransfer ||
                            !transfers.inboundTransfer,
                    }"
                >
                    <h2 class="paddingtop5">
                        <span class="darkblue priceSpan">
                            €
                            {{
                                roundPrice(
                                    (parseInt(inboundTransferPrice) +
                                        parseInt(outboundTransferPrice)) /
                                        totalPax
                                )
                            }}
                            <small>p.p.</small></span
                        >
                    </h2>
                  <div v-if="   transfers.inboundTransfer &&
                            transfers.outboundTransfer
                            " style="text-align: center;height:38px;line-height:38px;"><u><b>Geselecteerd</b></u></div>
                  <button v-else
                          class="btn btn-success btn-addon width100 font14 bold" style="margin-bottom: 5px;"
                        
                  >
                    Selecteer <font-awesome-icon icon="angle-right" />
                  </button>
                </td>
            </tr>

            <tr
                v-if="
                    flights &&
                        flights.results &&
                        flights.results[0] &&
                        outboundTransferPrice > 0
                "
                class="pointer "
                v-on:click="
                    setAndEmit(true, false, outboundTransferPrice, false)
                "
                :class="{
                        selectedRow:                   transfers.outboundTransfer &&
                                !transfers.inboundTransfer
                    }"
            >
                <td align="center" class="sm-border" style="border-top: 1px solid #ddd;">
                    <input
                        type="radio"
                        name="outboundTransfer"
                        value="OUT"
                        :checked="
                            transfers.outboundTransfer &&
                                !transfers.inboundTransfer
                        "
                    />
                </td>
                <td class="sm-hide-border" style="border-top: 1px solid #ddd;">
                    <div class="width90 sm-my-15 bottomborder" style="float:left;width:90%;">
                        <div style="float:left;width:5%;">
                            <font-awesome-icon icon="bus" />
                        </div>

                        <div
                            class="width90"
                            style="float:left;padding-left: 10px; width:calc(95% - 10px)"
                        >
                            Transfer van
                            <strong>{{
                                flights.results[0].outbound[0].arrivalAirport
                            }}</strong>
                            naar de <strong>Cruiseterminal</strong>.
                        </div>
                    </div>
                </td>
                <td
                    align="center"
                    style="border-top: 1px solid #ddd;"
                    :class="{
                        dim:
                            !transfers.outboundTransfer ||
                            transfers.inboundTransfer,
                    }"
                >
                    <h2 class="paddingtop5">
                        <span class="darkblue priceSpan">
                            €
                            {{ roundPrice(outboundTransferPrice / totalPax) }}
                            <small>p.p.</small></span
                        >
                    </h2>

                  <div v-if=" transfers.outboundTransfer &&
                                !transfers.inboundTransfer" style="text-align: center;height:38px;line-height:38px;"><u><b>Geselecteerd</b></u></div>
                  <button v-else
                          class="btn btn-success btn-addon width100 font14 bold" style="margin-bottom: 5px;"
                        
                  >
                    Selecteer <font-awesome-icon icon="angle-right" />
                  </button>
                </td>
            </tr>

            <tr
                v-if="
                    flights &&
                        flights.results &&
                        flights.results[0] &&
                        inboundTransferPrice > 0
                "
                class="pointer "
                v-on:click="
                    setAndEmit(false, true, inboundTransferPrice, false)
                "
                :class="{
                        selectedRow:   transfers.inboundTransfer &&
                                !transfers.outboundTransfer
                    }"
            >
                <td align="center" class="sm-border" style="border-top: 1px solid #ddd;">
                    <input
                        type="radio"
                        name="transfers.inboundTransfer"
                        value="NO"
                        :checked="
                            transfers.inboundTransfer &&
                                !transfers.outboundTransfer
                        "
                    />
                </td>
                <td class="sm-hide-border" style="border-top: 1px solid #ddd;">
                    <div class="width90 sm-my-15 bottomborder" style="float:left;width:90%">
                        <div style="float:left;width:5%;">
                            <font-awesome-icon icon="bus" />
                        </div>

                        <div
                            class="width90"
                            style="float:left;padding-left: 10px; width:calc(95% - 10px)"
                        >
                            Transfer van de <strong>Cruiseterminal</strong> naar
                            <strong>{{
                                flights.results[0].inbound[0].departureAirport
                            }}</strong>
                        </div>
                    </div>
                </td>
                <td class=""
                    align="center"
                    style="border-top: 1px solid #ddd;"
                    :class="{
                        dim:
                            !transfers.inboundTransfer ||
                            transfers.outboundTransfer,
                    }"
                >
                    <h2 class="paddingtop5">
                        <span class="darkblue priceSpan">
                            € {{ roundPrice(inboundTransferPrice / totalPax) }}
                            <small>p.p.</small></span
                        >
                    </h2>


                  <div v-if="transfers.inboundTransfer &&
                                !transfers.outboundTransfer" style="text-align: center;height:38px;line-height:38px;"><u><b>Geselecteerd</b></u></div>
                  <button v-else
                          class="btn btn-success btn-addon width100 font14 bold" style="margin-bottom: 5px;"
                        
                  >
                    Selecteer <font-awesome-icon icon="angle-right" />
                  </button>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBus } from '@fortawesome/free-solid-svg-icons'

library.add(faBus)

export default {
    name: 'Transfers',
    data: function() {
        return { transfersOpAanvraag: false }
    },
    props: {
        transfers: Object,
        cruise: Object,
        flights: Object,
        totalPax: Number,
        outboundTransferPrice: Number,
        inboundTransferPrice: Number,
    },
    methods: {
        setAndEmit: function(
            outboundTransfer,
            inboundTransfer,
            price,
            opAanvraag
        ) {
            this.transfers.outboundTransfer = outboundTransfer
            this.transfers.inboundTransfer = inboundTransfer
            this.transfers.totalPrice = price
            this.transfers.opAanvraag = opAanvraag
            this.$emit('transfer-selected-click')
        },
        roundPrice: function(price) {
            let parsed = parseFloat(price).toFixed(2)
            return parsed
                .split('.')
                .join(',')
                .replace(',00', ',-')
        },
    },
}
</script>

<style scoped>
.selectedRow{
  background: #f3f9fd;
}
@media screen and (max-width: 742px) {
  .bottomborder {
    border-bottom: solid 1px rgb(221,221,221);
    width: 102% !important;
  }
  .sm-border {
    border-top: 15px solid rgba(225, 225, 225, 40%) !important;
  }
  .sm-hide-border {
    border-top: 0px !important;
  }
  .sm-my-15 {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .priceSpan {
    display: inline-block;
  }
}
</style>
